import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Component } from '@angular/core';
@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent {
  constructor(public bsModalRef: BsModalRef) {}

  public title = '';
  public message = '';
  public strongText = '';
  public messageEnd = '';
  public buttonText = 'OK!';
  public buttonType = 'success';
  public resultado: Subject<boolean> = new Subject();

  cancelar() {
    this.resultado.next(false);
    this.bsModalRef.hide();
  }

  confirmar() {
    this.resultado.next(true);
    this.bsModalRef.hide();
  }
}
